<div class="header flex">
	<p class="m-0" i18n="Image Editor Header@@imageEditorHeader">{{ data.title || 'Image Editor' }}</p>
	<div class="right">
		<button mat-mini-fab color="tertiary" (click)="skip()">
			<mat-icon>close</mat-icon>
		</button>
	</div>
</div>

<div class="overall-container flex">


	<!-- Tool Selector Sidebar (only if multiple tools) -->
	<div class="tool-selector-sidebar" *ngIf="filteredToolOptions.length > 1">
		<button
			*ngFor="let tool of filteredToolOptions"
			class="tool-selector-button"
			[class.active]="activeToolOption?.id === tool.id"
			(click)="setActiveTool(tool)"
			[matTooltip]="tool.name"
			matTooltipPosition="right">
			<mat-icon>{{ tool.icon }}</mat-icon>
		</button>
	</div>



	<!-- Focal Area Cropping Mode -->
	<ng-container *ngIf="isFocalAreaMode()">
		<app-focal-area-cropping
			[asset]="activeAsset$ | async"
			[selectMode]="isSelectMode()"
			[initialTargetCrop]="data.initialTargetCrop"
			[creativeUnits]="data.creativeUnits"
			(assetUpdated)="setActiveAsset($event)"
			(focalAreaSelected)="onFocalAreaSelected($event)"
		></app-focal-area-cropping>
	</ng-container>
	
	<!-- Default Mode -->
	<ng-container *ngIf="!isFocalAreaMode()">
		<!-- Sidebar -->
		<div class="sidebar-container">
			<app-image-editor-sidebar
				[class.hidden]="data.config?.minimizeSidebar"
				[activeAsset]="activeAsset$ | async"
				[config]="data.config"
				[activeToolOptionInput]="activeToolOption"
				(setActiveAsset)="setActiveAsset($event)"
				(setActiveVariations)="setActiveVariations($event)"
				(setActiveToolOption)="activeToolOption = $event"
				(setConfig)="setConfigValue($event)"
				(setLoadingMessage)="loadingMessage = $event"
				(setFilteredTools)="onFilteredToolsChanged($event)"
			></app-image-editor-sidebar>

			<div class="sidebar-toggle" (click)="toggleSidebar()">
				<mat-icon *ngIf="!data.config?.minimizeSidebar">chevron_left</mat-icon>
				<mat-icon *ngIf="data.config?.minimizeSidebar">chevron_right</mat-icon>
			</div>
		</div>


	<!-- Preview Container -->
	<div class="preview-container flex flex-column">
		<!-- Large Loading Screen -->
		<div class="loading-overlay" *ngIf="loadingMessage">
			<div class="loading-content">
				<mat-spinner diameter="60" color="primary"></mat-spinner>
				<p class="loading-text mat-3">{{ loadingMessage }}</p>
			</div>
		</div>
		<!-- Image Variation Picker Tray -->
		<app-image-editor-variation-tray
			*ngIf="activeAssetVariations$ | async as variations"
			[assets]="variations"
			(setActiveAsset)="setActiveAsset($event)"
		></app-image-editor-variation-tray>

		<!-- Preview-->
		<div class="preview" [class.block]="activeToolOption?.id === 'target-crop'" [class.no-padding]="activeToolOption.config?.noPadding">
			<ng-container *ngIf="activeAsset$ | async as asset">
				<ng-container [ngSwitch]="activeToolOption?.id">

					<ng-container *ngSwitchCase="'target-crop'">
						<image-cropper
							[imageURL]="asset.assetPath | cloudinaryImageTransform:{ quality: 'q_auto:eco' }"
							[backgroundColor]="'#ffffff'"
							[maintainAspectRatio]="data.config?.targetCropConfig?.maintainAspectRatio && data.config?.targetCropConfig?.aspectRatio"
							[aspectRatio]="data.config?.targetCropConfig?.aspectRatio"
							[imagePosition]="initialTargetCrop"
							(imageCropped)="onImageCrop($event)"
							(cropperReady)="this.setConfigValue(this.originalConfig)"
							(imageLoaded) = "setImagesize($event)"
						></image-cropper>
					</ng-container>

					<div *ngSwitchCase="'bria-iframe'" class="bria-iframe">
						<mat-spinner diameter="40"></mat-spinner>
						<app-bria-iframe
							[asset]="activeAsset$ | async"
							[iframeId]="data.config?.dataSource?.config?.target"
							(saveImage)="setActiveAsset({ assetPath: $event }); save();"
						></app-bria-iframe>
					</div>

					<div *ngSwitchCase="'photopea-iframe'" class="photopea-iframe">
						<mat-spinner diameter="40"></mat-spinner>
						<app-photopea-iframe
							[asset]="activeAsset$ | async"
							(saveImage)="setActiveAsset({ assetPath: $event }); save();"
						></app-photopea-iframe>
					</div>

					<ng-container *ngSwitchDefault>
						<img [src]="asset.assetPath">
					</ng-container>
				</ng-container>
			</ng-container>
			<ng-container *ngIf="!(activeAsset$ | async)">
				<div class="no-content">
					<mat-icon>image</mat-icon>
					<p i18n="No Image Placeholder@@imageEditorNoImagePlaceholder">Use the sidebar inputs to get started.</p>
				</div>
			</ng-container>
		</div>

		<div *ngIf="!activeToolOption?.config?.hideFooter" class="action-bar flex">
			<div class="left">
				<ng-container *ngIf="!activeToolOption?.config?.hideUndoRedo">
					<button mat-mini-fab class="button-extra-small mr-3" color="tertiary" (click)="undo()" tp="Undo" [disabled]="undoStack.length < 2">
						<mat-icon>undo</mat-icon>
					</button>
					<button mat-mini-fab class="button-extra-small mr-3" color="tertiary" (click)="redo()" tp="Redo" [disabled]="!redoStack.length">
						<mat-icon>redo</mat-icon>
					</button>
					<button mat-mini-fab class="button-extra-small" color="tertiary" (click)="reset()" tp="Reset" [disabled]="undoStack.length < 2">
						<mat-icon>restart_alt</mat-icon>
					</button>
				</ng-container>
			</div>
			<div class="right">
				<button mat-flat-button color="primary" (click)="save()">
					<span class="text" i18n="Done Button@@imageEditorDoneButtonLabel">Done</span>
				</button>
			</div>
		</div>
		</div>
	</ng-container>
</div>
